import React from 'react';
import CaseStudiesPageContent from '../sections/CaseStudiesPageContent';

export const CaseStudiesPage: React.FC = () => {
  return (
    <CaseStudiesPageContent preview={false} />
  );
};

export default CaseStudiesPage;

